import { render, staticRenderFns } from "./OnboardingIntegrations.vue?vue&type=template&id=3bf42030&"
import script from "./OnboardingIntegrations.vue?vue&type=script&lang=js&"
export * from "./OnboardingIntegrations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports